module.exports = __webpack_public_path__ + "static/media/TP_Icon_Koozie.c65bed8b.png";